import { render, staticRenderFns } from "./RequirementsSection.vue?vue&type=template&id=66faa4ac&scoped=true&"
import script from "./RequirementsSection.vue?vue&type=script&lang=js&"
export * from "./RequirementsSection.vue?vue&type=script&lang=js&"
import style0 from "./RequirementsSection.vue?vue&type=style&index=0&id=66faa4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66faa4ac",
  null
  
)

export default component.exports